import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout = ({
  children
}: LayoutProps) => {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-124">
      <Header data-id="element-125" />
      <main className="flex-grow" data-id="element-126">{children}</main>
      <Footer data-id="element-127" />
    </div>;
};